import CardDaypartFit from './CardDaypartFit';
import './CardDaypartFit.scss';

export default CardDaypartFit;
